import { useEffect, useState } from 'react';

export const useAutoCompleteFocus = ({
  parentRef,
  onFocused,
  onBlurred,
}: {
  parentRef: React.RefObject<HTMLDivElement>;
  onFocused?: () => void;
  onBlurred?: () => void;
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
    if (onFocused) {
      onFocused();
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (onBlurred) {
      onBlurred();
    }
  };

  useEffect(() => {
    if (parentRef.current) {
      //parent is found find the input
      const autoCompleteInput = parentRef.current.querySelector(`input`);
      if (autoCompleteInput) {
        autoCompleteInput.addEventListener(`focus`, handleFocus);
        autoCompleteInput.addEventListener(`blur`, handleBlur);
      }
    }

    return () => {
      if (parentRef.current) {
        /*We could probably store the input in a ref to avoid this querySelector but if the input is removed from the dom this would fail
              so i'll leave it like this for now*/

        // eslint-disable-next-line react-hooks/exhaustive-deps
        const autoCompleteInput = parentRef.current.querySelector(`input`);
        if (autoCompleteInput) {
          autoCompleteInput.removeEventListener(`focus`, handleFocus);
          autoCompleteInput.removeEventListener(`blur`, handleBlur);
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentRef.current]);

  return {
    isFocused,
  };
};
